export function formatTimeString(timeStr) {
  if (!timeStr) return "";

  const [hourStr, minuteStr] = timeStr.split(":");
  const hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  const period = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;

  return `${hour12}.${minute.toString().padStart(2, "0")} ${period}`;
}

export function formatTimeRange(startTime, endTime) {
  return `${formatTimeString(startTime)} - ${formatTimeString(endTime)}`;
}

export function format12Hour(time){
    return `${formatTimeString(time)}` ;
}
